<template>
    <el-card class="mt15">
        <template slot='header'>
        <div>{{title}}</div>
        </template>
        <el-upload
            :action="api"
            :data="formData"
            :limit="2"
            list-type="picture-card"
            :file-list="fileList"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :on-success="fileUploadSuccess"
            :on-error="fileUploadError"
            ref="upload">
             <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </el-card>
</template>
<script>
    export default {
        name: 'LyImgUpload',
        props: {
            api: String,
            id: {
                type: [String, Number],
                default: ''
            }, // 附带上传的ID（目前是指单据详情的ID）
            title: {
                type: String,
                default: '图片附件'
            },
            data: {
                type: Object,
                default: () => {}
            },
            list: {
                type: Array,
                default: () => []
            },
            max: {
                type: Number,
                default: 5
            }, // 上传图片的上限
            callback: Function, // 图片上传成功后的回调
            delCallback: Function, // 图片删除的回调
            delData: {
                type: Object,
                default: () => {}
            }, // 删除需要的额外参赛
            canDelete: {
                type: Boolean,
                default: true
            } // 标识是否有删除权限
        },
        computed: {
            /**
             * 附带上传参数的数据
             */
            formData () {
                let obj = this.data || {}
                obj['id'] = this.id
                return obj
            }
        },
        data () {
            return {
                dialogImageUrl: '',
                dialogVisible: false,
                fileList: [],
                length: 0 // 用于记录图片的数量
            }
        },
        created () {
            if (this.list.length > 0) {
                this.fileList = this.fileList.concat(this.list)
                this.length = this.fileList.length
            }
        },
        watch: {
            list (val) {
                this.fileList = this.fileList.concat(val)
                this.length = this.fileList.length
            }
        },
        methods: {
            /**
             * 图片上传之前的检查
             * @param  {[type]} file [description]
             * @return {[type]}      [description]
             */
            beforeUpload (file) {
                if (this.length >= this.max) {
                    this.$message.error('已达到上传上限')
                    return false
                }
                const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                  this.$message.error('上传图片只能是 jpg/png 格式!')
                }
                if (!isLt2M) {
                  this.$message.error('上传图片大小不能超过 2MB!')
                }
                return isJPG && isLt2M
            },
            /** 
             * 图片的删除
             */
            handleRemove (file, fileList) {
                if (!this.canDelete) {
                    this.$message({
                        message: '你没有删除权限',
                        type: 'warning'
                    })
                } else {
                    if (!file) return
                    let api = this.api.indexOf('/') === 0 ? this.api.replace('/', '') : this.api
                    let id = file.id ? file.id : file.response.data.id
                    api += '/' + id
                    this.$api.delete(api, this.delData).then((rs) => {
                        this.length--
                        if (this.delCallback) {
                            this.delCallback()
                        }
                    }).catch((err) => {
                        this.$message({
                            message: err,
                            type: 'warning'
                        })
                    })
                }
            },
            /**
             * 查看大图的监听
             */
            handlePictureCardPreview (file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            /**
             * 文件上传成功
             */
            fileUploadSuccess (response, file, fileList) {
                if (response.status === 200) {
                    // 将返回的ID 添加到列表中
                    // this.fileList.push(response.data)
                    this.length++
                    if (this.callback) {
                        this.callback(response.data)
                    }
                } else {
                    this.$message({
                        message: response.msg,
                        type: 'warning'
                    })
                }
            },
            /**
             * 上传失败的提示
             */
            fileUploadError (err, file, fileList) {
                this.$message({
                    message: err,
                    type: 'warning'
                })
            }
        }
    }
</script>